<template>
  <div v-if="hasWarnings()" class="license-warnings">
    <n-alert
      v-for="warning in warnings"
      :key="warning.module_name"
      :type="getWarningType(warning)"
      :title="warning.is_expired ? 'License Expired' : 'License Expiring Soon'"
      closable
      class="license-alert"
    >
      {{ getWarningMessage(warning) }}
    </n-alert>
  </div>
</template>

<script setup>
import { NAlert } from 'naive-ui'
import { useLicense } from '../composables/useLicense.js'

const { warnings, hasWarnings, getWarningType, getWarningMessage } = useLicense()
</script>

<style scoped>
.license-warnings {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.license-alert {
  border-radius: 0;
}

.license-alert + .license-alert {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
</style>
